import { THAID_REDIRECT_URI } from '@/config';

const THAID_CLIENT_ID = 'eWFBN0xZUXZzRjQ4cWFrS2Ezbjk4cDNrTE9xYlZMYVc';

// ข้อมูลผู้เข้าร่วมที่เลือกเก็บได้ ต้องตรงกับ meetingFields.js ฝั่ง backend
export const MEETING_FIELDS = [
  { key: 'name', label: 'ชื่อ-นามสกุล', adminOnly: false, required: true, scopes: ['name'],
    columns: [{ header: 'ชื่อ', value: 'name' }] },
  { key: 'pid', label: 'เลขบัตรประชาชน', adminOnly: false, scopes: ['pid'],
    columns: [{ header: 'ID_CARD', value: 'id_card' }] },
  { key: 'name_en', label: 'ชื่อภาษาอังกฤษ', adminOnly: true, scopes: ['name_en'],
    columns: [{ header: 'ชื่อ(EN)', value: 'name_en' }] },
  { key: 'birthdate', label: 'วันเกิด', adminOnly: true, scopes: ['birthdate'],
    columns: [{ header: 'วันเกิด', value: 'birthdate' }] },
  { key: 'address', label: 'ที่อยู่', adminOnly: true, scopes: ['address'],
    columns: [{ header: 'ที่อยู่', value: 'address' }] },
  { key: 'card_dates', label: 'วันออกบัตร / วันบัตรหมดอายุ', adminOnly: true, scopes: ['date_of_issuance', 'date_of_expiry'],
    columns: [{ header: 'วันที่ออกบัตร', value: 'date_of_issuance' }, { header: 'วันที่บัตรหมดอายุ', value: 'date_of_expiry' }] },
];

// ค่าที่ติ๊กไว้ให้ตอนสร้างการประชุมใหม่
export const DEFAULT_FIELDS = ['name'];

// ข้อมูลที่ผู้ใช้ทั่วไปเลือกได้ และค่าของการประชุมเก่า (alldata = 0) ที่เก็บชื่อกับเลขบัตรเสมอ
const BASIC_FIELDS = ['name', 'pid'];

const ALL_KEYS = MEETING_FIELDS.map(f => f.key);

function selected(fields) {
  return MEETING_FIELDS.filter(f => fields.indexOf(f.key) !== -1);
}

// เพิ่มข้อมูลบังคับ (ชื่อ-นามสกุล) เสมอ และเรียงตามลำดับมาตรฐาน (ตรงกับ backend)
export function withRequired(fields) {
  const required = MEETING_FIELDS.filter(f => f.required).map(f => f.key);
  const all = fields.concat(required);
  return ALL_KEYS.filter(k => all.indexOf(k) !== -1);
}

// การประชุมเก่าที่ยังไม่มี fields ใช้ค่า alldata เดิม
export function fieldsOf(meeting) {
  if (meeting && meeting.fields) {
    const keys = String(meeting.fields).split(',');
    return ALL_KEYS.filter(k => keys.indexOf(k) !== -1);
  }
  return meeting && meeting.alldata ? ALL_KEYS.slice() : BASIC_FIELDS.slice();
}

// ลิงก์ ThaID สำหรับ QR: ขอเฉพาะข้อมูลที่เลือก
export function buildThaidLink(meetingId, fields) {
  const scope = selected(fields).reduce((all, f) => all.concat(f.scopes), []).join('%20');
  return `https://imauth.bora.dopa.go.th/api/v2/oauth2/auth/?response_type=code&client_id=${THAID_CLIENT_ID}`
    + `&redirect_uri=${THAID_REDIRECT_URI}&scope=${scope}&state=${meetingId}`;
}

// คอลัมน์สำหรับ export Excel ตามข้อมูลที่เลือก
export function exportColumns(fields) {
  return selected(fields).reduce((all, f) => all.concat(f.columns), []);
}
